
import React from "react";
import { useNotifications } from "../hooks/useNotifications";

const NotificationBadge = () => {
  const { unreadCount } = useNotifications();

  if (!unreadCount) return null;

  return (
    <span className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center rounded-full bg-destructive text-destructive-foreground text-xs font-medium animate-in fade-in zoom-in duration-200">
      {unreadCount > 9 ? '9+' : unreadCount}
    </span>
  );
};

export default NotificationBadge;
